"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StateRequireStatuarySurchargeNotice = void 0;
const usStatesAndTerritories_1 = require("../../locations/usStatesAndTerritories");
const StatesWhereStatuarySurchargeNoticesRequired = [
    usStatesAndTerritories_1.UnitedStatesStateTerritoryKey.Colorado,
    usStatesAndTerritories_1.UnitedStatesStateTerritoryKey.Minnesota,
    usStatesAndTerritories_1.UnitedStatesStateTerritoryKey.NewJersey,
    usStatesAndTerritories_1.UnitedStatesStateTerritoryKey.NewYork,
];
/**
 * Does the state require a statuary surcharge notice?
 * @param state
 * @returns
 */
const StateRequireStatuarySurchargeNotice = (state) => StatesWhereStatuarySurchargeNoticesRequired.includes(state);
exports.StateRequireStatuarySurchargeNotice = StateRequireStatuarySurchargeNotice;
//# sourceMappingURL=StateRequiresStatuarySurchargeNotice.js.map